import { IAddressZipcode } from "../../../Models/IAddressZipcode";
import { ISafegraphLocation } from "../../../Models/ISafegraphLocation";
import * as MobilyticsApi from "../API/MobilyticsApi";
import { ICustomPolygon } from "../Models/Maps/ICustomPolygon";
import { customPolygonFromPoints } from "./PolygonLogic";

export const getSafeGraphLocations = async (safegraphLocationIds: string[]): Promise<ISafegraphLocation[]> => {
    return await MobilyticsApi.getSafeGraphLocations(safegraphLocationIds);
};

export const getPolygonFromSafegraphPlace = (place: ISafegraphLocation): ICustomPolygon => {
    return customPolygonFromPoints(place.polygon);
};

export const getAddressAndZipcodeFromGooglePlaceResult = (details: google.maps.places.PlaceResult): IAddressZipcode => {
    const streetNumberComponent = details?.address_components?.find(c => c.types.some(t => t === "street_number"));
    const routeComponent = details?.address_components?.find(c => c.types.some(t => t === "route"));
    const zipcodeComponent = details?.address_components?.find(c => c.types.some(t => t === "postal_code"));
    const address = `${streetNumberComponent?.short_name} ${routeComponent?.short_name}`;
    const zipcode = zipcodeComponent?.short_name;

    return {
        address,
        zipcode
    };
};